var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4414 23.9532L23.4361 11.9776C22.7328 10.7584 21.422 10.0017 20.0043 10C18.5866 9.99834 17.2753 10.752 16.5632 11.9777L9.5553 23.9576C8.82863 25.1795 8.81219 26.7105 9.51605 27.9592C10.2205 29.2089 11.5395 29.9866 12.9743 29.9983L27.0121 29.9983C28.4618 29.9842 29.7783 29.2089 30.4827 27.9603C31.1862 26.7132 31.1704 25.1856 30.4414 23.9532ZM11.278 24.9737L18.2911 12.9849C18.6462 12.3735 19.2976 11.9992 20.002 12C20.7063 12.0008 21.3574 12.3767 21.7067 12.9822L28.7176 24.9672C29.0851 25.5885 29.0929 26.3533 28.7407 26.9777C28.388 27.603 27.7286 27.9913 27.0024 27.9984L12.9824 27.9983C12.2718 27.9925 11.6111 27.6029 11.2583 26.9771C10.9059 26.3519 10.9141 25.5855 11.278 24.9737ZM20.0002 25.9983C20.5527 25.9983 21.0005 25.5506 21.0005 24.9983C21.0005 24.4461 20.5527 23.9983 20.0002 23.9983C19.4477 23.9983 18.9999 24.4461 18.9999 24.9983C18.9999 25.5506 19.4477 25.9983 20.0002 25.9983ZM21.0035 15.9983H19.0028V22.9983H21.0035V15.9983Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.84429817.svg";
export { ForwardRef as ReactComponent };